
$(document).ready(function() {
	$(".product-rating-start").mouseover(function() {
		let rating = $(this).data('rating');
		for(let i = 1; i <= rating; i++) {
			$('#rating-start-' + i).find('i').removeClass('fa-star-o').addClass('fa-star');
		}
	}).mouseout(function() {
		$(".product-rating-start").find('i').removeClass('fa-star').addClass('fa-star-o');
	});

	$(".product-rating-start").click(function(event) {
		event.preventDefault();

		let rating = $(this).data('rating');

		$('#product-rating-form').attr('data-rating', rating);

		for(let i = 1; i <= 5; i++) {
			if (i <= rating) {
				$('.rating-form-stars').append('<i class="fa fa-star" aria-hidden="true"></i>');
			} else {
				$('.rating-form-stars').append('<i class="fa fa-star-o" aria-hidden="true"></i>');
			}
		}

		$('#product-rating-summary').hide();
		$('#product-rating-form').show();
	});

	let ratingIsLoading = false;
	$(document).on('click', '#save-rating-btn', function(e) {
		e.preventDefault();
		let productId = $(this).data('id');
		if (!productId) { return false; }

		let rating = $('#product-rating-form').data('rating');
		if (!rating) {
			alert('Invalid rating');
			return false;
		}

		if (ratingIsLoading) { return false; }
        ratingIsLoading = true;

		var values='';
        values+='id=' + productId;
        values+='&rating=' + rating;
        values+='&text=' + $('#rating-text').val();

        $.ajax({
            type: "POST",
            url: baseURL + "/product/rating",
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            dataType: "JSON",
            data: values,
            success: function(response) {
                ratingIsLoading = false;

				if (response.status == 0) {
					var errorHtml = '';
					for(var errorKey in response.errors) {
						if(!response.errors.hasOwnProperty(errorKey)) continue;
						for(var error in response.errors[errorKey]) {
							errorHtml += response.errors[errorKey][error] + '<br>';
						}
					}

					$('#rating-notifications').html('<div class="alert alert-danger">'+errorHtml+'</div>');
					return false;
				}

				if (response.status == 2 || response.status == 3 || response.status == 4 || response.status == 5) {
					$('#rating-notifications').html('<div class="alert alert-danger">'+response.message+'</div>');
					return false;
				}

				if (response.status == 1) {
					$('#rating-notifications').html('<div class="alert alert-success">'+response.message+'</div>');

					$('#product-rating-form').attr('data-rating', '');
					$('#product-rating-summary').show();
					$('#product-rating-form').hide();

					return false;
				}

				$('#rating-notifications').html('<div class="alert alert-danger">Error: Something went wrong please contact and administrator!</div>');
				return false;
			},
			error(error) {
                ratingIsLoading = false;
				$('#rating-notifications').html('<div class="alert alert-danger">Error: Something went wrong please contact and administrator!</div>');
            }
		});
	});

	$(".go-to-reviews").click(function (){
        $('html, body').animate({
            scrollTop: $("#product-rating-summary").offset().top
        }, 1500);
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/ratings.js